<template>
  <modal
      :id="sessionStatusModalId"
  >
    <div class="add-user">
      <b-row>
        <b-col>
          <close-button
              class="float-right"
              @close-button-click="handleCloseBtnClick"
          />
        </b-col>
      </b-row>
      <h3>Edit Session Status</h3>
      <b-row>
        <b-col>
          <b-row class="status-box">
            <b-col>
              <h5>Updates : {{ statusStage }} </h5>
              <template v-if="docStage">
                <p>Date: <date-format-toggle :date="docStage._created_at"/></p>
                <p>Status: {{ docStage.status ? docStage.status : '' }}</p>
                <p>Changes</p>
              </template>
              <b-button
                  variant="warning"
                  block
              >
                Needs Work
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-row class="status-box">
            <b-col>
              <h5>Doc : {{ statusPublish }} </h5>
              <template v-if="doc">
                <p>Date: <date-format-toggle :date="doc._created_at"/></p>
                <p>Status: {{ doc.status ? doc.status : '' }}</p>
                <p>Changes</p>
              </template>
              <b-button
                  variant="danger"
                  block
              >
               Remove
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row style="margin-top: 15px;">
        <b-col>
          <b-button
              variant="warning"
              block
              @click="handlePublishBtnClick"
          >
            Publish Staging
          </b-button>
        </b-col>
      </b-row>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/common/modal";
import CloseButton from "@/components/common/closeButton";
import DateFormatToggle from "@/components/common/dateFormatToggle"
export default {
  name: "Admin_Manage_Sessions_UpdateStatus",
  components: {
    Modal,
    CloseButton,
    DateFormatToggle
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    statusPublish(){
      return this.sessionData && this.sessionData.status_publish ? this.sessionData.status_publish : 'Not Published'
    },
    statusStage(){
      return this.sessionData && this.sessionData.status_stage ? this.sessionData.status_stage: 'Not Changes'
    },
    doc(){
      return this.sessionData && this.sessionData.doc ? this.sessionData.doc: null
    },
    docStage(){
      return this.sessionData && this.sessionData.doc_stage ? this.sessionData.doc_stage: null
    },
  },
  mounted() {},
  methods: {
    handleOpenStatusModalForSessionData(sessionData){
      this.sessionData = sessionData;
      this.$bvModal.show(this.sessionStatusModalId);
    },
    handlePublishBtnClick() {
      //move doc_stage to doc
      //set stage_status to published
      //set publish_status to active
      debugger;
      const updates = {
        _updated_by: this.profile && this.profile.userId,
        status_stage:"published",
        status_publish:"active",
        doc_rollback: this.sessionData.doc ? this.sessionData.doc : null,
        doc: this.sessionData.doc_stage ? this.sessionData.doc_stage : this.sessionData.doc
      };

      if (!this.sessionData.slug) {
         updates.slug = updates.doc && updates.doc.title ? this.generateSlug(updates.doc.title) :null;
      }
      this.updateStatus(updates);
    },
    updateStatus(updates) {
      this.$store.dispatch("admin/updateSessionListing",
          {
            id: this.sessionData.id,
            ownerId: this.sessionData.doc_stage && this.sessionData.owner  && this.sessionData.owner.userId  ?
                 this.sessionData.owner.userId : null,
            updates
          }
      ).then(() => {
        this.handleRefreshData();
        this.session = null;
        this.modalStatus = null;
        this.$bvModal.hide(this.sessionStatusModalId);
      });
    },
    handleCloseBtnClick() {
      this.sessionData = null;
      this.$bvModal.hide(this.sessionStatusModalId);
    },
    generateSlug(title) {
      //Check for existing
      return  title ? title
          .replace(/\s+/g, "-")
          .toLowerCase() : null;
    },
  },
  data() {
    return {
      sessionStatusModalId: `edit-session-status`,
      docStatus: null, //|all | submitted | needs_work | inactive
      docLevel: "doc_stage", //doc, doc_stage //versions, doc_local |all | submitted | needs_work | inactive
      sessionData: null,
      modalStatus: null,
      statusOptions: [
        { value: null, text: "Please select an option" },
        { value: "submitted", text: "Submitted" },
        { value: "need_work", text: "Needs Work" },
        { value: "publish", text: "Publish" },
        { value: "republish", text: "Update Publish" },
        { value: "inactive", text: "Inactive/Remove" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
</style>
